import * as React from 'react';
import androidSelected from '../../../assets/android-selected.svg';
import androidUnselected from '../../../assets/android-unselected.svg';
import androidDisabledSelected from '../../../assets/android-disabled-selected.svg';
import androidDisabledUnselected from '../../../assets/android-disabled-unselected.svg';
import amazonSelected from '../../../assets/amazon-selected.svg';
import amazonUnselected from '../../../assets/amazon-unselected.svg';
import amazonDisabledSelected from '../../../assets/amazon-disabled-selected.svg';
import amazonDisabledUnselected from '../../../assets/amazon-disabled-unselected.svg';
import huaweiSelected from '../../../assets/huawei-selected.svg';
import huaweiUnselected from '../../../assets/huawei-unselected.svg';
import huaweiDisabledSelected from '../../../assets/huawei-disabled-selected.svg';
import huaweiDisabledUnselected from '../../../assets/huawei-disabled-unselected.svg';
import samsungSelected from '../../../assets/samsung-selected.svg';
import samsungUnselected from '../../../assets/samsung-unselected.svg';
import samsungDisabledSelected from '../../../assets/samsung-disabled-selected.svg';
import samsungDisabledUnselected from '../../../assets/samsung-disabled-unselected.svg';

import { IconProps } from '../../typescriptHelpers';
import { AppStoreType } from '../../types';

interface AndroidAppIconProps extends IconProps {
    isSelected: boolean;
    isDisabledTreatment: boolean;
    appStoreType?: AppStoreType;
}

const AndroidAppIcon: React.FC<AndroidAppIconProps> = (props: AndroidAppIconProps) => {
    let selectedImage: string;
    let unselectedImage: string;
    let disabledSelectedImage: string;
    let disabledUnselectedImage: string;

    switch (props.appStoreType) {
        case AppStoreType.Amazon:
            selectedImage = amazonSelected;
            unselectedImage = amazonUnselected;
            disabledSelectedImage = amazonDisabledSelected;
            disabledUnselectedImage = amazonDisabledUnselected;
            break;
        case AppStoreType.Huawei:
            selectedImage = huaweiSelected;
            unselectedImage = huaweiUnselected;
            disabledSelectedImage = huaweiDisabledSelected;
            disabledUnselectedImage = huaweiDisabledUnselected;
            break;
        case AppStoreType.Samsung:
            selectedImage = samsungSelected;
            unselectedImage = samsungUnselected;
            disabledSelectedImage = samsungDisabledSelected;
            disabledUnselectedImage = samsungDisabledUnselected;
            break;
        default:
            selectedImage = androidSelected;
            unselectedImage = androidUnselected;
            disabledSelectedImage = androidDisabledSelected;
            disabledUnselectedImage = androidDisabledUnselected;
            break;
    }

    let sourceImage = props.isSelected ? selectedImage : unselectedImage;
    if (props.isDisabledTreatment) {
        sourceImage = props.isSelected ? disabledSelectedImage : disabledUnselectedImage;
    }

    return <img src={sourceImage} width={props.width} height={props.height} />;
};

export default AndroidAppIcon;
